import MicroComponents from "@system/config/micro-components";

export default class ComponentBasedApp {
    getComponent = () => {
        let r = [];
        MicroComponents.chain.map((v) => {
            r.push({
                element: v.element,
                name: v.name,
            })
        });
        return r;
    }
}